export interface Manga {
  id: string;
  title: string;
  cover: string;
  category: string;
  tags: string[];
  sweetness: number;
  artStyle: string;
  status: string;
  rating: number;
  chapters: number;
  latest: string;
  author: string;
  desc: string;
}

export const categories = [
  { name: "甜宠", icon: "ri-heart-3-line", desc: "全程发糖，宠上天", seq: "cat-tianchong" },
  { name: "恋爱", icon: "ri-heart-line", desc: "心动日常，双向奔赴", seq: "cat-lianai" },
  { name: "高甜", icon: "ri-cup-line", desc: "糖分拉满，甜到齁", seq: "cat-gaotian" },
  { name: "少女", icon: "ri-moon-clear-line", desc: "少女心，青春初恋", seq: "cat-shaonv" },
  { name: "纯爱", icon: "ri-sparkling-2-line", desc: "细水长流，慢慢心动", seq: "cat-chunai" },
  { name: "狗粮", icon: "ri-cake-3-line", desc: "恋爱公开，甜到饱", seq: "cat-gouliang" },
];

export const artStyles = ["清新", "温暖", "精致", "明亮", "细腻", "文艺", "梦幻", "活泼"];

export const mangaList: Manga[] = [
  {
    id: "lianai-tangguo-shouce",
    title: "恋爱糖果手册",
    cover: "https://readdy.ai/api/search-image?query=Cute%20anime%20illustration%20of%20a%20shy%20high%20school%20boy%20and%20girl%20holding%20hands%20under%20blooming%20pink%20cherry%20blossom%20trees%2C%20warm%20pastel%20tones%2C%20soft%20dreamy%20background%2C%20sweet%20romance%20manga%20cover%20style%2C%20clean%20composition%2C%20vibrant%20colors&width=600&height=800&seq=manga-cover-01&orientation=portrait",
    category: "恋爱",
    tags: ["校园", "纯爱", "初恋"],
    sweetness: 4.5,
    artStyle: "清新",
    status: "连载中",
    rating: 4.6,
    chapters: 128,
    latest: "第128话 草莓之约",
    author: "糖豆",
    desc: "转学来的学霸少女偶然捡到一本「恋爱糖果手册」，从此每一次心动都会收到一颗神秘糖果。糖纸背后写着的小纸条，究竟是巧合，还是有人在偷偷写着关于她的心事？",
  },
  {
    id: "gebi-de-tianshishi",
    title: "隔壁的甜品师",
    cover: "https://readdy.ai/api/search-image?query=Warm%20anime%20illustration%20of%20a%20cheerful%20pastry%20chef%20girl%20holding%20a%20strawberry%20cream%20cake%20beside%20a%20cute%20boy%2C%20cozy%20pastel%20bakery%20background%20with%20cakes%2C%20sweet%20romance%20manga%20cover%2C%20soft%20lighting%2C%20pastel%20color%20palette&width=600&height=800&seq=manga-cover-02&orientation=portrait",
    category: "甜宠",
    tags: ["美食", "治愈", "邻居"],
    sweetness: 4.8,
    artStyle: "温暖",
    status: "连载中",
    rating: 4.8,
    chapters: 96,
    latest: "第96话 焦糖苹果派",
    author: "奶油泡芙",
    desc: "楼下新搬来的甜品师总在打烊后多留一份甜点给他。明明只是「试吃」，他却越来越习惯这份专属的糖分。隔壁的香气，究竟是谁先心动？",
  },
  {
    id: "xindong-heyue",
    title: "心动契约",
    cover: "https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20cool%20young%20man%20in%20a%20suit%20and%20a%20graceful%20girl%20exchanging%20a%20pink%20contract%20document%2C%20elegant%20modern%20city%20background%2C%20sweet%20contract%20romance%20manga%20cover%2C%20soft%20warm%20tones%2C%20refined%20details&width=600&height=800&seq=manga-cover-03&orientation=portrait",
    category: "高甜",
    tags: ["契约", "都市", "职场"],
    sweetness: 4.6,
    artStyle: "精致",
    status: "已完结",
    rating: 4.7,
    chapters: 156,
    latest: "第156话 契约的终点",
    author: "柠檬汽水",
    desc: "为了应付家里安排的相亲，她和他签下一份「假恋爱契约」。条款写满了恋爱注意事项，却漏了最重要的一条：契约到期那天，谁都不许先心动。",
  },
  {
    id: "caomeiwei-de-xiantian",
    title: "草莓味的夏天",
    cover: "https://readdy.ai/api/search-image?query=Fresh%20anime%20illustration%20of%20a%20teenage%20girl%20holding%20strawberries%20in%20summer%20school%20uniform%2C%20youthful%20cheerful%20vibe%2C%20bright%20green%20and%20pink%20summer%20background%2C%20shoujo%20manga%20cover%20style%2C%20clean%20pastel%20colors&width=600&height=800&seq=manga-cover-04&orientation=portrait",
    category: "少女",
    tags: ["青春", "初恋", "夏日"],
    sweetness: 4.2,
    artStyle: "清新",
    status: "连载中",
    rating: 4.5,
    chapters: 74,
    latest: "第74话 落日汽水",
    author: "青柠海",
    desc: "转学前的最后一个暑假，她在海边小镇遇见爱画漫画的他。一个关于夏天、草莓味汽水和没说出口的告白的温柔故事。",
  },
  {
    id: "aijiao-xuezhang-de-wanan",
    title: "傲娇学长的晚安",
    cover: "https://readdy.ai/api/search-image?query=Cute%20anime%20illustration%20of%20a%20tsundere%20senior%20boy%20with%20slightly%20blushing%20cheeks%20looking%20away%20while%20a%20girl%20smiles%2C%20school%20rooftop%20at%20sunset%2C%20warm%20golden%20light%2C%20sweet%20romance%20manga%20cover%2C%20bright%20cheerful%20pastel%20style&width=600&height=800&seq=manga-cover-05&orientation=portrait",
    category: "甜宠",
    tags: ["校园", "傲娇", "学长"],
    sweetness: 4.7,
    artStyle: "明亮",
    status: "连载中",
    rating: 4.9,
    chapters: 112,
    latest: "第112话 晚安短信",
    author: "落日煎蛋",
    desc: "全校闻名的傲娇学长，嘴上总说「才不是特意等你」，却每天傍晚准时出现在天台。晚安短信的署名，永远只有一个人。",
  },
  {
    id: "wenquan-lyguan-lianai",
    title: "温泉旅馆恋爱事",
    cover: "https://readdy.ai/api/search-image?query=Gentle%20anime%20illustration%20of%20a%20couple%20in%20yukata%20enjoying%20a%20hot%20spring%20ryokan%20with%20lanterns%20and%20steam%2C%20traditional%20Japanese%20warm%20atmosphere%2C%20cozy%20romance%20manga%20cover%2C%20soft%20warm%20color%20palette%2C%20detailed%20background&width=600&height=800&seq=manga-cover-06&orientation=portrait",
    category: "狗粮",
    tags: ["和风", "治愈", "温泉"],
    sweetness: 4.3,
    artStyle: "细腻",
    status: "已完结",
    rating: 4.6,
    chapters: 88,
    latest: "第88话 回温的约定",
    author: "山茶花",
    desc: "回到外婆留下的温泉旅馆打理生意的她，遇见了每年冬天都来住店的旅人。一间小旅馆、一池温泉，和一段慢慢升温的恋爱。",
  },
  {
    id: "yuese-yu-mao",
    title: "月色与猫",
    cover: "https://readdy.ai/api/search-image?query=Dreamy%20anime%20illustration%20of%20a%20calm%20boy%20and%20girl%20sitting%20under%20moonlight%20with%20a%20cute%20white%20cat%20beside%20them%2C%20cozy%20balcony%20at%20night%2C%20soft%20moonlight%20with%20warm%20lamp%20accents%2C%20pure%20love%20manga%20cover%2C%20artistic%20soft%20style&width=600&height=800&seq=manga-cover-07&orientation=portrait",
    category: "纯爱",
    tags: ["都市", "慢热", "宠物"],
    sweetness: 4.0,
    artStyle: "文艺",
    status: "连载中",
    rating: 4.4,
    chapters: 60,
    latest: "第60话 窗台的约定",
    author: "白露",
    desc: "加班到深夜的两个人，因为一只走丢的白猫在楼道相遇。他们没有交换名字，却每天在同一扇窗台喂猫。月光下，话很少，心动却很长。",
  },
  {
    id: "lianai-buke-shijian",
    title: "恋爱补课时间",
    cover: "https://readdy.ai/api/search-image?query=Cute%20anime%20illustration%20of%20a%20studious%20girl%20tutoring%20a%20boy%20at%20a%20desk%20full%20of%20books%20and%20tea%2C%20warm%20classroom%20light%2C%20playful%20sweet%20romance%20manga%20cover%2C%20bright%20pastel%20colors%2C%20clean%20cheerful%20composition&width=600&height=800&seq=manga-cover-08&orientation=portrait",
    category: "恋爱",
    tags: ["校园", "学霸", "补习"],
    sweetness: 4.4,
    artStyle: "俏皮",
    status: "连载中",
    rating: 4.5,
    chapters: 104,
    latest: "第104话 课后的答案",
    author: "橡皮擦",
    desc: "为了不让全校第一的学霸学姐给自己补课，他拼命想考差，却总是莫名其妙地及格。习题本上的红圈越来越多，而她看他的眼神也越来越奇怪。",
  },
  {
    id: "yinghuase-de-gaobai",
    title: "樱花色的告白",
    cover: "https://readdy.ai/api/search-image?query=Beautiful%20anime%20illustration%20of%20a%20girl%20confessing%20to%20a%20boy%20under%20a%20huge%20cherry%20blossom%20tree%20with%20petals%20swirling%2C%20dreamy%20pink%20scene%2C%20shoujo%20romance%20manga%20cover%2C%20vibrant%20soft%20pastel%20colors%2C%20romantic%20atmosphere&width=600&height=800&seq=manga-cover-09&orientation=portrait",
    category: "少女",
    tags: ["青春", "樱花", "告白"],
    sweetness: 4.9,
    artStyle: "梦幻",
    status: "已完结",
    rating: 4.9,
    chapters: 132,
    latest: "第132话 樱花开时",
    author: "春日信",
    desc: "她在樱花树下练习了整整三年的告白，却在毕业前收到了别人的情书。属于樱花色的青春，会走向怎样的结局？",
  },
  {
    id: "tongju-de-diyitian",
    title: "同居的第一天",
    cover: "https://readdy.ai/api/search-image?query=Lively%20anime%20illustration%20of%20a%20young%20couple%20moving%20boxes%20into%20a%20cozy%20apartment%20laughing%20together%2C%20warm%20morning%20light%2C%20happy%20domestic%20romance%20manga%20cover%2C%20bright%20cheerful%20pastel%20colors&width=600&height=800&seq=manga-cover-10&orientation=portrait",
    category: "狗粮",
    tags: ["同居", "日常", "高甜"],
    sweetness: 4.8,
    artStyle: "活泼",
    status: "连载中",
    rating: 4.8,
    chapters: 85,
    latest: "第85话 早餐的默契",
    author: "煎蛋壳",
    desc: "因为合租才认识的一对欢喜冤家，从抢厕所到共用冰箱，从手忙脚乱到习以为常。同居的第一天开始，心动的每一天都在加码。",
  },
  {
    id: "shenming-daren-de-xiaoshitang",
    title: "神明大人的小食堂",
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20anime%20illustration%20of%20a%20kind%20god%20character%20serving%20food%20in%20a%20magical%20small%20diner%2C%20cute%20girl%20customer%2C%20whimsical%20warm%20atmosphere%20with%20floating%20lights%2C%20healing%20romance%20manga%20cover%2C%20dreamy%20pastel%20colors&width=600&height=800&seq=manga-cover-11&orientation=portrait",
    category: "纯爱",
    tags: ["奇幻", "治愈", "食堂"],
    sweetness: 4.5,
    artStyle: "梦幻",
    status: "连载中",
    rating: 4.7,
    chapters: 98,
    latest: "第98话 夜的汤",
    author: "云朵饭团",
    desc: "街角有间只在夜里开门的小食堂，老板自称是「下岗神明」。每个失意的客人，都会得到一碗会发光的汤。直到某天，他遇见了能尝出汤里心意的人。",
  },
  {
    id: "xuezhang-de-xindong-xinhao",
    title: "学长的心动信号",
    cover: "https://readdy.ai/api/search-image?query=Fresh%20anime%20illustration%20of%20a%20boy%20sending%20a%20playful%20signal%20with%20heart%20balloons%20to%20a%20girl%20across%20campus%2C%20cute%20sparkles%2C%20bright%20daytime%20background%2C%20school%20romance%20manga%20cover%2C%20clean%20vibrant%20pastel%20colors&width=600&height=800&seq=manga-cover-12&orientation=portrait",
    category: "恋爱",
    tags: ["校园", "心动", "信号"],
    sweetness: 4.6,
    artStyle: "清新",
    status: "连载中",
    rating: 4.6,
    chapters: 70,
    latest: "第70话 信号满格",
    author: "北极星",
    desc: "学长总在各种巧合里出现：占座、送伞、在她生日时点亮整栋楼的灯。她以为是巧合，直到发现那些「偶遇」背后，藏着一整套「心动信号」。",
  },
];

export const heroCover =
  "https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20of%20a%20cozy%20reading%20scene%20with%20romance%20manga%20books%2C%20pudding%20desserts%2C%20cupcakes%20and%20soft%20clouds%2C%20warm%20pastel%20peach%20and%20pink%20palette%2C%20dreamy%20soft%20background%2C%20cheerful%20sweet%20atmosphere%2C%20clean%20minimal%20composition&width=1400&height=900&seq=hero-pudding-2026&orientation=landscape";